export enum PunchFunctionEnums {
  UNKNOWN = 0,
  IN = 1, // In
  OUT = 2, // Out
  BB = 3, // Break Begin
  BE = 4, // Break End
  DEPT = 5, // Department Punch
  JOB = 6, // Job Punch
  GROUPJOB = 7, // Group job punch
  GROUPDEPT = 8, // Group Department punch
  WORKOUT = 9, // Work-out, left site but still working
  GROUPWORKOUT = 10, // Group work-out
  CUSTOM1 = 11, // Custom Punch 1
  CUSTOM2 = 12, // Custom Punch 2
  CUSTOM3 = 13, // Custom Punch 3
  CUSTOM4 = 14, // Custom Punch 4
  CUSTOM5 = 15, // Custom Punch 5
  CUSTOM6 = 16, // Custom Punch 6
}
